export const defaultLineSettings = {
  lineAt: '@mexicano',
  linkLine: 'https://lin.ee/Ohc1YLF'
}
